export const ENTRY_POINT = 'ENTRY_POINT';
export const WARRANTY = 'WARRANTY';
export const VOUCHER = 'VOUCHER';
export const DETAIL_WARRANTY = 'DETAIL_WARRANTY';
export const POST_RATING_WARRANTY = 'POST_RATING_WARRANTY';
export const DETAIL_VOUCHER = 'DETAIL_VOUCHER';
export const POST_CLAIM_VOUCHER = 'POST_CLAIM_VOUCHER';
export const INSURANCE = 'INSURANCE';
export const DETAIL_INSURANCE = 'DETAIL_INSURANCE';
export const POST_INSURANCE_APPLICATION = 'POST_INSURANCE_APPLICATION';

export const urls = {
    getEntryPointMyBenefits: '/api/v2/users/myBenefit',
    getWarranties: (cursor, limit) => `/api/users/warranties?cursor=${cursor}&limit=${limit}`,
    postReviewWarranty: '/api/users/warranties',
    getDetailWarranty: id => `/api/users/warranties/${id}`,
    getVouchers: (cursor, limit) => `/api/users/vouchers?cursor=${cursor}&limit=${limit}`,
    getDetailVoucher: id => `/api/users/vouchers/${id}`,
    postClaimVoucher: '/api/users/vouchers',
    getInsurances: (cursor, limit) => `/api/users/insurances?cursor=${cursor}&limit=${limit}`,
    getDetailInsurance: id => `/api/users/insurances/${id}`,
    postInsuranceApplication: '/api/users/insurances/leads'
};

export const initialState = {
    dataMyBenefits: null,
    isSuccessGetMyBenefits: false,
    isFetchingGetMyBenefits: false,
    isErrorGetMyBenefits: false,
    dataVouchers: null,
    isSuccessGetVouchers: false,
    isFetchingGetVouchers: false,
    isErrorGetVouchers: false,
    dataDetailVoucher: {
        status: '',
        data: {
            id: 0,
            banner: '',
            name: '',
            description: '',
            partner_details: {
                name: '',
                logo: '',
                contact: [],
                legal_name: ''
            },
            code: '',
            start_date: '',
            end_date: '',
            claimed_date: '',
            status: '',
            is_active: false,
            is_claim_enabled: false
        },
        metadata: null
    },
    isSuccessGetDetailVoucher: false,
    isFetchingGetDetailVoucher: true,
    isErrorGetDetailVoucher: false,
    dataWarranties: null,
    isSuccessGetWarranties: false,
    isFetchingGetWarranties: false,
    isErrorGetWarranties: false,
    dataDetailWarranty: null,
    isSuccessGetDetailWarranty: false,
    isFetchingGetDetailWarranty: false,
    isErrorGetDetailWarranty: false,
    isSuccessPostRatingWarranty: false,
    isFetchingPostRatingWarranty: false,
    isErrorPostRatingWarranty: false,
    isSuccessPostClaimVoucher: false,
    isFetchingPostClaimVoucher: false,
    isErrorPostClaimVoucher: false,
    dataInsurances: null,
    isSuccessGetInsurances: false,
    isFetchingGetInsurances: false,
    isErrorGetInsurances: false,
    dataDetailInsurance: null,
    isSuccessGetDetailInsurance: false,
    isFetchingGetDetailInsurance: false,
    isErrorGetDetailInsurance: false,
    isFetchingPostInsuranceApplication: false,
    isSuccessPostInsuranceApplication: false,
    isErrorPostInsuranceApplication: false
};

export default (state = initialState, action) => {
    switch (action.type) {
        case `REQUEST_${ENTRY_POINT}`: {
            return {
                ...state,
                isSuccessGetMyBenefits: false,
                isFetchingGetMyBenefits: true,
                isErrorGetMyBenefits: false
            };
        }
        case `RECEIVE_${ENTRY_POINT}`: {
            return {
                ...state,
                isSuccessGetMyBenefits: true,
                isFetchingGetMyBenefits: false,
                isErrorGetMyBenefits: false,
                dataMyBenefits: action.data
            };
        }
        case `ERROR_${ENTRY_POINT}`:
            return {
                ...state,
                isSuccessGetMyBenefits: false,
                isFetchingGetMyBenefits: false,
                isErrorGetMyBenefits: true,
                dataMyBenefits: null
            };
        case `REQUEST_${WARRANTY}`: {
            return {
                ...state,
                isSuccessGetWarranties: false,
                isFetchingGetWarranties: true,
                isErrorGetWarranties: false
            };
        }
        case `RECEIVE_${WARRANTY}`: {
            return {
                ...state,
                isSuccessGetWarranties: true,
                isFetchingGetWarranties: false,
                isErrorGetWarranties: false,
                dataWarranties: state.dataWarranties ? { ...action.data, data: [...state.dataWarranties.data, ...action.data.data] } : action.data
            };
        }
        case `ERROR_${WARRANTY}`:
            return {
                ...state,
                isSuccessGetWarranties: false,
                isFetchingGetWarranties: false,
                isErrorGetWarranties: true
            };
        case `REQUEST_${VOUCHER}`: {
            return {
                ...state,
                isSuccessGetVouchers: false,
                isFetchingGetVouchers: true,
                isErrorGetVouchers: false
            };
        }
        case `RECEIVE_${VOUCHER}`: {
            return {
                ...state,
                isSuccessGetVouchers: true,
                isFetchingGetVouchers: false,
                isErrorGetVouchers: false,
                dataVouchers: state.dataVouchers ? { ...action.data, data: [...state.dataVouchers.data, ...action.data.data] } : action.data
            };
        }
        case `ERROR_${VOUCHER}`: {
            return {
                ...state,
                isSuccessGetVouchers: false,
                isFetchingGetVouchers: false,
                isErrorGetVouchers: true
            };
        }
        case `REQUEST_${DETAIL_WARRANTY}`: {
            return {
                ...state,
                isSuccessGetDetailWarranty: false,
                isFetchingGetDetailWarranty: true,
                isErrorGetDetailWarranty: false
            };
        }
        case `RECEIVE_${DETAIL_WARRANTY}`: {
            return {
                ...state,
                isSuccessGetDetailWarranty: true,
                isFetchingGetDetailWarranty: false,
                isErrorGetDetailWarranty: false,
                dataDetailWarranty: action.data
            };
        }
        case `ERROR_${DETAIL_WARRANTY}`:
            return {
                ...state,
                isSuccessGetDetailWarranty: false,
                isFetchingGetDetailWarranty: false,
                isErrorGetDetailWarranty: true,
                dataDetailWarranty: null
            };
        case `REQUEST_${POST_RATING_WARRANTY}`:
            return {
                ...state,
                isSuccessPostRatingWarranty: false,
                isFetchingPostRatingWarranty: true,
                isErrorPostRatingWarranty: false
            };
        case `ERROR_POST_${POST_RATING_WARRANTY}`:
            return {
                ...state,
                isSuccessPostRatingWarranty: false,
                isFetchingPostRatingWarranty: false,
                isErrorPostRatingWarranty: true
            };
        case `RESPONSE_POST_${POST_RATING_WARRANTY}`:
            return {
                ...state,
                isSuccessPostRatingWarranty: true,
                isFetchingPostRatingWarranty: false,
                isErrorPostRatingWarranty: false
            };
        case `REQUEST_${DETAIL_VOUCHER}`: {
            return {
                ...state,
                isSuccessGetDetailVoucher: false,
                isFetchingGetDetailVoucher: true,
                isErrorGetDetailVoucher: false
            };
        }
        case `RECEIVE_${DETAIL_VOUCHER}`: {
            return {
                ...state,
                isSuccessGetDetailVoucher: true,
                isFetchingGetDetailVoucher: false,
                isErrorGetDetailVoucher: false,
                dataDetailVoucher: action.data
            };
        }
        case `ERROR_${DETAIL_VOUCHER}`:
            return {
                ...state,
                isSuccessGetDetailVoucher: false,
                isFetchingGetDetailVoucher: false,
                isErrorGetDetailVoucher: true,
                dataDetailVoucher: null
            };
        case `REQUEST_${POST_CLAIM_VOUCHER}`:
            return {
                ...state,
                isSuccessPostClaimVoucher: false,
                isFetchingPostClaimVoucher: true,
                isErrorPostClaimVoucher: false
            };
        case `ERROR_POST_${POST_CLAIM_VOUCHER}`:
            return {
                ...state,
                isSuccessPostClaimVoucher: false,
                isFetchingPostClaimVoucher: false,
                isErrorPostClaimVoucher: true
            };
        case `RESPONSE_POST_${POST_CLAIM_VOUCHER}`:
            return {
                ...state,
                isSuccessPostClaimVoucher: true,
                isFetchingPostClaimVoucher: false,
                isErrorPostClaimVoucher: false,
                dataDetailVoucher: { ...state.dataDetailVoucher, data: { ...state.dataDetailVoucher.data, ...action?.data?.data }}
            };
        case `REQUEST_${INSURANCE}`: {
            return {
                ...state,
                isSuccessGetInsurances: false,
                isFetchingGetInsurances: true,
                isErrorGetInsurances: false
            };
        }
        case `RECEIVE_${INSURANCE}`: {
            return {
                ...state,
                isSuccessGetInsurances: true,
                isFetchingGetInsurances: false,
                isErrorGetInsurances: false,
                dataInsurances: state.dataInsurances ? { ...action.data, data: [...state.dataInsurances.data, ...action.data.data] } : action.data
            };
        }
        case `ERROR_${INSURANCE}`:
            return {
                ...state,
                isSuccessGetInsurances: false,
                isFetchingGetInsurances: false,
                isErrorGetInsurances: true
            };
        case `REQUEST_${DETAIL_INSURANCE}`: {
            return {
                ...state,
                isSuccessGetDetailInsurance: false,
                isFetchingGetDetailInsurance: true,
                isErrorGetDetailInsurance: false
            };
        }
        case `RECEIVE_${DETAIL_INSURANCE}`: {
            return {
                ...state,
                isSuccessGetDetailInsurance: true,
                isFetchingGetDetailInsurance: false,
                isErrorGetDetailInsurance: false,
                dataDetailInsurance: action.data
            };
        }
        case `ERROR_${DETAIL_INSURANCE}`:
            return {
                ...state,
                isSuccessGetDetailInsurance: false,
                isFetchingGetDetailInsurance: false,
                isErrorGetDetailInsurance: true,
                dataDetailInsurance: null
            };
        case `REQUEST_${POST_INSURANCE_APPLICATION}`:
            return {
                ...state,
                isSuccessPostInsuranceApplication: false,
                isFetchingPostInsuranceApplication: true,
                isErrorPostInsuranceApplication: false
            };
        case `ERROR_POST_${POST_INSURANCE_APPLICATION}`:
            return {
                ...state,
                isSuccessPostInsuranceApplication: false,
                isFetchingPostInsuranceApplication: false,
                isErrorPostInsuranceApplication: true
            };
        case `RESPONSE_POST_${POST_INSURANCE_APPLICATION}`:
            return {
                ...state,
                isSuccessPostInsuranceApplication: true,
                isFetchingPostInsuranceApplication: false,
                isErrorPostInsuranceApplication: false
            };
        default:
            return state;
    }
};
